import React, { useEffect, useMemo, useState } from 'react';
import './ArchivePage.css';
import './TestsPage.css';
import { getTests } from './testManager';
import lectureImage from './assets/tests/lecture_vp.png';
import ishiharaImage from './assets/tests/ishihara.png';
import epaisseurImage from './assets/tests/epaisseur.png';

const TEST_CARDS = [
  {
    id: 'reading-vp',
    title: 'Test de lecture VP',
    description: 'Lignes de lecture avec caractères de plus en plus petits.',
    info: 'Mode clinique simple, plein écran possible.',
    action: 'reading-test',
    button: '👓 Ouvrir',
  },
  {
    id: 'ishihara',
    title: 'Test Ishihara',
    description: 'Planches libres de dépistage daltonien rouge-vert.',
    info: 'Navigation planche par planche avec score final.',
    action: 'ishihara-test',
    button: '🎨 Ouvrir',
  },
  {
    id: 'manual-thickness',
    title: "Calcul d'épaisseur manuel",
    description: 'Étude indépendante des archives, sans photo, avec saisie monture + Rx.',
    info: 'Sauvegarde locale possible dans la section tests.',
    action: 'manual-thickness-test',
    button: '📐 Ouvrir',
  },
];

export default function TestsPage({ goTo }) {
  const [manualStudiesCount, setManualStudiesCount] = useState(0);

  useEffect(() => {
    let active = true;

    async function load() {
      try {
        const studies = await getTests();
        const manualStudies = studies.filter((item) => item.type === 'manualThickness');
        if (active) {
          setManualStudiesCount(manualStudies.length);
        }
      } catch (error) {
        console.error(error);
      }
    }

    load();

    return () => {
      active = false;
    };
  }, []);

  const getCardImage = (cardId) => {
    if (cardId === 'reading-vp') return lectureImage;
    if (cardId === 'ishihara') return ishiharaImage;
    return epaisseurImage;
  };

  const getCardBadge = (cardId) => {
    if (cardId === 'reading-vp') return 'VP';
    if (cardId === 'ishihara') return 'CB';
    return 'ET';
  };

  return (
    <div className="archives-container tests-container">
      <h1>Tests optiques</h1>


      <div className="archive-grid">
        {TEST_CARDS.map((card) => (
          <div
  key={card.id}
  className="archive-card glass-card test-card"
  onClick={() => goTo(card.action)}
  style={{ cursor: "pointer" }}
>
            <div
              className="test-card-image"
              style={{ backgroundImage: `url(${getCardImage(card.id)})` }}
              onClick={() => goTo(card.action)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  goTo(card.action);
                }
              }}
            >
            </div>

            <div className="archive-header test-card-header">
              <h3 className="archive-name">{card.title}</h3>
            </div>

            <div className="archive-info test-card-info">
              <p>{card.description}</p>
              <p>{card.info}</p>
              {card.id === 'manual-thickness' && (
                <p>
                  <strong>Sauvegardes :</strong> {manualStudiesCount}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>

      <button className="back-btn" onClick={() => goTo('home')}>
        ⬅ Retour
      </button>
    </div>
  );
}